import { PLAYER } from './config';
import type { DriveState, NormalizedInput } from './models';

export interface DriveMotion {
  drive: DriveState;
  linearSpeed: number;
  angularSpeed: number;
}

export function clampTread(value: number): number {
  return Number.isFinite(value) ? Math.max(-1, Math.min(1, value)) : 0;
}

function approach(current: number, target: number, maximumDelta: number): number {
  if (Math.abs(target - current) <= maximumDelta) return target;
  return current + Math.sign(target - current) * maximumDelta;
}

export function updateDrive(
  current: DriveState,
  input: Pick<NormalizedInput, 'leftTread' | 'rightTread'>,
  delta: number,
): DriveMotion {
  const maximumDelta = delta / PLAYER.treadRampSeconds;
  const leftTread = approach(current.leftTread, clampTread(input.leftTread), maximumDelta);
  const rightTread = approach(current.rightTread, clampTread(input.rightTread), maximumDelta);
  const average = (leftTread + rightTread) / 2;
  const reverseScale = average < 0 ? PLAYER.reverseMultiplier : 1;
  return {
    drive: { leftTread, rightTread },
    linearSpeed: PLAYER.forwardSpeed * average * reverseScale,
    angularSpeed: (PLAYER.pivotRate * (rightTread - leftTread)) / 2,
  };
}
